'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.getAirOptionJourneys = getAirOptionJourneys;
exports.getBase = getBase;
exports.getMarkupLabel = getMarkupLabel;
exports.getFeeLabel = getFeeLabel;
exports.getObFeeLabel = getObFeeLabel;
exports.getMarkupAmount = getMarkupAmount;
exports.getFeeAmount = getFeeAmount;
exports.getObFeeAmount = getObFeeAmount;
exports.getCurrency = getCurrency;
exports.getRules = getRules;
exports.getTax = getTax;
exports.getTotal = getTotal;
exports.getTotalValue = getTotalValue;
exports.isSplitTicketing = isSplitTicketing;
exports.getDisclaimerText = getDisclaimerText;
exports.getAirJourneySegments = getAirJourneySegments;
exports.getAirJourneyDuration = getAirJourneyDuration;
exports.getAirJourneyDestination = getAirJourneyDestination;
exports.getSegmentDestination = getSegmentDestination;
exports.getAirJourneyOrigin = getAirJourneyOrigin;
exports.getSegmentOrigin = getSegmentOrigin;
exports.getAircraft = getAircraft;
exports.getAirSegmentDuration = getAirSegmentDuration;
exports.getArrivalDateTime = getArrivalDateTime;
exports.getBaggageAllowance = getBaggageAllowance;
exports.getCabinClass = getCabinClass;
exports.getBookingClass = getBookingClass;
exports.getCarrier = getCarrier;
exports.getDepartureDateTime = getDepartureDateTime;
exports.getNotAvailable = getNotAvailable;
exports.getDestinationTerminal = getDestinationTerminal;
exports.getFlightNumber = getFlightNumber;
exports.numberOfPassengers = numberOfPassengers;
exports.getOperatedBy = getOperatedBy;
exports.getOriginTerminal = getOriginTerminal;
exports.getStopovers = getStopovers;
exports.getLastDateToPurchase = getLastDateToPurchase;
exports.getAirAvailabilityDestination = getAirAvailabilityDestination;
exports.getAirAvailabilityOptionSegments = getAirAvailabilityOptionSegments;
exports.getAirAvailabilityOrigin = getAirAvailabilityOrigin;
exports.getAirAvailabilityDepartureDate = getAirAvailabilityDepartureDate;
exports.getAirAvailabilityJourneys = getAirAvailabilityJourneys;
exports.getHotelName = getHotelName;
exports.getHotelDescription = getHotelDescription;
exports.getHotelAddress = getHotelAddress;
exports.getHotelTotal = getHotelTotal;
exports.getHotelTotalCurrency = getHotelTotalCurrency;
exports.getHotelImagesURL = getHotelImagesURL;
exports.getHotelIsActive = getHotelIsActive;
exports.getHotelMeal = getHotelMeal;
exports.getHotelBedType = getHotelBedType;
exports.getHotelRoomView = getHotelRoomView;
exports.getHotelNonRefundable = getHotelNonRefundable;
exports.getTaxDisplay = getTaxDisplay;
exports.getHotelPriceFooterMessage = getHotelPriceFooterMessage;
exports.getHotelPricePerNightDescriptors = getHotelPricePerNightDescriptors;
exports.getRefundableText = getRefundableText;
exports.getHotelPriceDescriptorTitle = getHotelPriceDescriptorTitle;
exports.getHotelPriceDescriptorPrice = getHotelPriceDescriptorPrice;
exports.numberOfNights = numberOfNights;
exports.getHotelPriceDescriptorTax = getHotelPriceDescriptorTax;
exports.getHotelNumberOfNights = getHotelNumberOfNights;
exports.getHotelVendorCode = getHotelVendorCode;
exports.getCarPickupDateTime = getCarPickupDateTime;
exports.getCarDropOffDateTime = getCarDropOffDateTime;
exports.getCarPickupCityCode = getCarPickupCityCode;
exports.getCarDropOffCityCode = getCarDropOffCityCode;
exports.getCarPickupCityName = getCarPickupCityName;
exports.getCarDropOffCityName = getCarDropOffCityName;
exports.getCarPickupCountryName = getCarPickupCountryName;
exports.getCarDropOffCountryName = getCarDropOffCountryName;
exports.getCarPickupIsAirport = getCarPickupIsAirport;
exports.getCarPickupAirportCode = getCarPickupAirportCode;
exports.getCarDropOffAirportCode = getCarDropOffAirportCode;
exports.getCarPickupLocationName = getCarPickupLocationName;
exports.getCarDropOffLocationName = getCarDropOffLocationName;
exports.getCarExactLocationPickup = getCarExactLocationPickup;
exports.getCarExactLocationDropoff = getCarExactLocationDropoff;
exports.getCarRentalCompanyName = getCarRentalCompanyName;
exports.getCarTypeDescription = getCarTypeDescription;
exports.getCarRate = getCarRate;
exports.getCarRateCurrency = getCarRateCurrency;
exports.getCarRateType = getCarRateType;
exports.getCarTotal = getCarTotal;
exports.getCarTotalCurrency = getCarTotalCurrency;
exports.getCarVendorCode = getCarVendorCode;
exports.getCarRatePerDistance = getCarRatePerDistance;
exports.getCarRatePerDistanceUnits = getCarRatePerDistanceUnits;
exports.getSymbolBeforeFlightNumber = getSymbolBeforeFlightNumber;
exports.getCarRatePerDistanceCurrency = getCarRatePerDistanceCurrency;
exports.getCardNumber = getCardNumber;
exports.getReceiptNumber = getReceiptNumber;
exports.getCurrencyCode = getCurrencyCode;
exports.getCardTypeText = getCardTypeText;
exports.getFromZoneName = getFromZoneName;
exports.getFromZoneCode = getFromZoneCode;
exports.getToZoneName = getToZoneName;
exports.getToZoneCode = getToZoneCode;
exports.getValidFrom = getValidFrom;
exports.getValidTo = getValidTo;
exports.getVendorName = getVendorName;
exports.getRailCardOperatedBy = getRailCardOperatedBy;
exports.getClassName = getClassName;
exports.getClassCode = getClassCode;
exports.getEquipement = getEquipement;
exports.getTariffCode = getTariffCode;
exports.getPassengerTypeCode = getPassengerTypeCode;
exports.getDiscount = getDiscount;
exports.getRailCardPrice = getRailCardPrice;
exports.getAction = getAction;
exports.getTravelerName = getTravelerName;
exports.getRulesItemNumber = getRulesItemNumber;
exports.getRulesfareReference = getRulesfareReference;
exports.getReferenceNumber = getReferenceNumber;
exports.getTimeFormat = getTimeFormat;
exports.addComma = addComma;
exports.addBrackets = addBrackets;
exports.existVal = existVal;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _formatDuration = require('helpers/formatDuration');

var _formatDuration2 = _interopRequireDefault(_formatDuration);

var _priceString = require('helpers/priceString');

var _priceString2 = _interopRequireDefault(_priceString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
All these getters act on an object. In essence, they act as methods on a class.
As such, they should return `undefined` when the object they're working on does
not have the requested data.

It's up to the calling code to correctly handle the values returned by these
getters.
*/

/*
Helpers for `Air` related data. Ordered first by argument object (option,
journey, segment) and then alphabetically.
*/

function getAirOptionJourneys(option) {
  return option.journeys;
}

function getBase(option) {
  return option.optionPrice.totalPriceItem.priceData.basePrice;
}

function getMarkupLabel(option) {
  return option.optionPrice.totalPriceItem.priceData.markupName;
}

function getFeeLabel(option) {
  return option.optionPrice.totalPriceItem.priceData.feeName;
}

function getObFeeLabel(option) {
  return option.optionPrice.totalPriceItem.priceData.obFeeName || '';
}

function getMarkupAmount(option) {
  return option.optionPrice.totalPriceItem.priceData.markupAmount;
}

function getFeeAmount(option) {
  return option.optionPrice.totalPriceItem.priceData.feeAmount;
}

function getObFeeAmount(option) {
  return option.optionPrice.totalPriceItem.priceData.obFeeAmount || 0;
}

function getCurrency(option) {
  return option.optionPrice.totalPriceItem.priceData.currency;
}

function getRules(option) {
  return option.rules;
}

function getTax(option) {
  return option.optionPrice.totalPriceItem.priceData.taxPrice;
}

function getTotal(option) {
  return (option.optionPrice.totalPriceItem.priceData.totalPrice + option.optionPrice.totalPriceItem.priceData.markupAmount + option.optionPrice.totalPriceItem.priceData.feeAmount + option.optionPrice.totalPriceItem.priceData.obFeeAmount || 0).toFixed(2);
}

function getTotalValue(ptc) {
  return ptc.priceData.totalPrice + ptc.priceData.markupAmount + ptc.priceData.feeAmount + ptc.priceData.obFeeAmount || 0;
}

function isSplitTicketing() {
  return false;
}

function getDisclaimerText(optionPrice) {
  return optionPrice.totalPriceItem.priceData.disclaimer;
}

function getAirJourneySegments(journey) {
  // a journey is an array of segments
  return journey;
}

/*
This function should no longer be used. It will not correctly calculate journey
durations. Instead, the duration property is provided in the Data Exchange
Fromat as an ASP.NET style time span. Recommended to use formatDuration helper
instead.
*/
function getAirJourneyDuration(journey) {
  var segments = getAirJourneySegments(journey);
  var start = (0, _moment2.default)(segments[0].startDateTime);
  var end = (0, _moment2.default)(segments[segments.length - 1].endDateTime);
  var duration = _moment2.default.duration(end.diff(start));

  var result = '';

  if (Math.floor(duration.days()) > 0) {
    result += Math.floor(duration.days()) + 'd ';
  }
  if (Math.floor(duration.hours()) > 0) {
    result += Math.floor(duration.hours()) + 'h ';
  }
  if (Math.floor(duration.minutes()) > 0) {
    result += Math.floor(duration.minutes()) + 'm';
  }

  return result;
}

function getAirJourneyDestination(journey) {
  var segments = getAirJourneySegments(journey);
  return segments[segments.length - 1].destination;
}

function getSegmentDestination(segment) {
  return segment.destination;
}

function getAirJourneyOrigin(journey) {
  var segments = getAirJourneySegments(journey);
  return segments[0].origin;
}

function getSegmentOrigin(segment) {
  return segment.origin;
}

function getAircraft(segment) {
  return segment && segment.equipmentType && segment.equipmentType.name;
}

function getAirSegmentDuration(segment) {
  return (0, _formatDuration2.default)(segment.duration);
}

function getArrivalDateTime(segment) {
  return segment.endDateTime;
}

function getBaggageAllowance(segment) {
  try {
    var fareLinks = segment.fareLinks;
    var numberOfPiecesAndPassengerType = fareLinks.map(function (fareLink) {
      return {
        passengerType: fareLink.fare.passengerType,
        numberOfPieces: fareLink.fareInfo.baggageAllowance.numberOfPieces,
        weight: fareLink.fareInfo.baggageAllowance.weight && fareLink.fareInfo.baggageAllowance.weight.value,
        unit: fareLink.fareInfo.baggageAllowance.weight && fareLink.fareInfo.baggageAllowance.weight.unit
      };
    });

    numberOfPiecesAndPassengerType.sort(function (a, b) {
      if (a.passengerType < b.passengerType) {
        return -1;
      }
      if (a.passengerType > b.passengerType) {
        return 1;
      }

      return 0;
    });

    var result = '';
    for (var i = 0; i < numberOfPiecesAndPassengerType.length; i++) {
      var np = numberOfPiecesAndPassengerType[i];
      if (np.weight && np.unit) {
        result += np.weight + ' ' + np.unit + '  (' + np.passengerType + ')' + (i !== numberOfPiecesAndPassengerType.length - 1 ? ', ' : ' ') + ' ';
      } else if (np.numberOfPieces > 0) {
        result += np.numberOfPieces + ' piece' + (np.numberOfPieces > 1 ? 's' : '') + ' (' + np.passengerType + ')' + (i !== numberOfPiecesAndPassengerType.length - 1 ? ', ' : ' ') + ' ';
      }
    }
    numberOfPiecesAndPassengerType.forEach(function (np) {});

    return result.length > 0 ? result : 'none';
  } catch (e) {
    return undefined;
  }
}

function getCabinClass(segment) {
  return segment && segment.classOfService;
}

function getBookingClass(segment) {
  return segment && segment.bookingClass;
}

/**
Gets segment Carrier
@param {object} segment Segment
@return {object} Carrier
*/
function getCarrier(segment) {
  return segment.carrier;
}

function getDepartureDateTime(segment) {
  return segment.startDateTime;
}

function getNotAvailable(t) {
  return t ? t('common.na') : 'N/A';
}

function getDestinationTerminal(segment, t) {
  return segment.destinationTerminal ? segment.destinationTerminal : getNotAvailable(t);
}

/**
Gets segment Carrier
@param {object} segment Segment
@return {string} Flight number
*/
function getFlightNumber(segment) {
  return String(segment.flightNumber);
}

function numberOfPassengers(segment) {
  var total = 0;
  for (var i = 0; i < segment.fareLinks.length; i++) {
    total += segment.fareLinks[i].fare.numberOfPassengers;
  }
  return total;
}

function getOperatedBy(segment) {
  return segment && (segment.operatedBy && segment.operatedBy.name || segment.operatingFlightName || segment.carrier && segment.carrier.name);
}

function getOriginTerminal(segment, t) {
  return segment.originTerminal ? segment.originTerminal : getNotAvailable(t);
}

/**
Returns array of city codes (strings) where the segment has stopovers. Will be
an empty array if no stopovers.
@param {string} segment Segment to inspect for stopovers
@returns {array} Array with zero or more city codes
*/
function getStopovers(segment) {
  try {
    var stopovers = [];
    if (segment.stopLegs && segment.stopLegs.length > 0) {
      var prevLeg = void 0;
      for (var i = 0; i < segment.stopLegs.length; i++) {
        var stopLeg = segment.stopLegs[i];
        if (prevLeg && prevLeg.destination.code === stopLeg.origin.code) {
          var name = stopLeg.origin.name;
          var cityName = stopLeg.origin.cityName;
          var departureDate = (0, _moment2.default)(stopLeg.departureDate);
          var arrivalDate = (0, _moment2.default)(prevLeg.arrivalDate);
          var duration = _moment2.default.duration(departureDate.diff(arrivalDate));
          var durationStr = duration.days() > 0 ? duration.days() + 'd ' : '';
          durationStr += duration.hours() > 0 || duration.days() > 0 && duration.minutes() > 0 ? duration.hours() + 'h ' : '';
          durationStr += duration.minutes() > 0 ? duration.minutes() + 'm ' : '';
          var changeOfPlaneStr = stopLeg.plane !== prevLeg.plane ? ', plane change required' : '';

          stopovers.push(name + ' (' + cityName + ', ' + durationStr + 'stop' + changeOfPlaneStr + ')');
        }
        prevLeg = stopLeg;
      }
    }

    if (stopovers.length) {
      return stopovers.join(', ');
    } else {
      return undefined;
    }
  } catch (e) {
    return undefined;
  }
}

function getLastDateToPurchase(option) {
  return option.lastDateToPurchaseTicket;
}

/*
Helpers for `AirAvailability` related data. Ordered first by argument object
(option, journey, segment) and then alphabetically.
*/

function getAirAvailabilityDestination(option) {
  return option.airAvailSearch.destination;
}

// TODO: shorten name
function getAirAvailabilityOptionSegments(option) {
  return option.listAirAvailLineOption.map(function (item) {
    return item.segment;
  });
}

function getAirAvailabilityOrigin(option) {
  return option.airAvailSearch.origin;
}

function getAirAvailabilityDepartureDate(option) {
  return option.airAvailSearch.departureDate;
}

function getAirAvailabilityJourneys(option) {
  var listAirAvailLineOption = option.listAirAvailLineOption;
  var journeys = [];
  var journey = [];
  for (var i = 0; i < listAirAvailLineOption.length; i++) {
    if (listAirAvailLineOption[i].isConnected) {
      journey.push((0, _extends3.default)({}, listAirAvailLineOption[i].segment, { index: i + 1 }));
    } else {
      journey.push((0, _extends3.default)({}, listAirAvailLineOption[i].segment, { index: i + 1 }));
      journeys.push(journey);
      journey = [];
    }
  }
  return journeys;
}

/*
Helpers for `Hotel` related data. Ordered first by argument object
(option, journey, segment) and then alphabetically.
*/

function getHotelName(option) {
  return option.hotelRoom.hotelProperty.longName;
}

function getHotelDescription(option) {
  return _lodash2.default.trim(option.hotelRoom.rateDescription.join(' '));
}

function getHotelAddress(option) {
  return _lodash2.default.trim(option.hotelRoom.hotelProperty.address, ' \n') + ' ' + option.hotelRoom.hotelProperty.location.cityName + ', ' + option.hotelRoom.hotelProperty.location.countryName + ' \n';
}

function getHotelTotal(option) {
  return option.optionPrice.totalPriceItem.priceData.totalPrice;
}

function getHotelTotalCurrency(option) {
  return option.optionPrice.totalPriceItem.priceData.currency;
}

function getHotelImagesURL(option) {
  return option.hotelRoom.hotelProperty.propertyIdentifier;
}

function getHotelIsActive(option) {
  return option.isActiveHotel;
}

function getHotelMeal(option, t) {
  return option.hotelRoom.meal || t('common.na');
}

function getHotelBedType(option, t) {
  return option.hotelRoom.bedType || t('common.na');
}

function getHotelRoomView(option, t) {
  return option.hotelRoom.rules.roomView || t('common.na');
}

function getHotelNonRefundable(option) {
  return option.hotelRoom.rules.nonrefundable;
}

function getTaxDisplay(ptc, text, currencyformat) {
  var currency = '';
  var finalTaxValue = ptc.priceData.taxPrice;
  var finalFeeLabel = void 0;
  var finalMarkupLabel = void 0;
  var finalObFeeLabel = void 0;

  if (ptc.priceData.markupDisplayMode === 'InTotalTax') {
    finalTaxValue += ptc.priceData.markupAmount;
  } else if (ptc.priceData.markupDisplayMode === 'InQuote') {
    finalMarkupLabel = ', ' + ptc.priceData.markupName + ' ' + (0, _priceString2.default)(currencyformat, ptc.priceData.markupAmount, currency);
  }
  if (ptc.priceData.feeDisplayMode === 'InTotalTax') {
    finalTaxValue += ptc.priceData.feeAmount;
  } else if (ptc.priceData.feeDisplayMode === 'InQuote') {
    finalFeeLabel = ', ' + ptc.priceData.feeName + ' ' + (0, _priceString2.default)(currencyformat, ptc.priceData.feeAmount, currency);
  }
  if (ptc.priceData.obFeeDisplayMode === 'InTotalTax') {
    finalTaxValue += ptc.priceData.obFeeAmount;
  } else if (ptc.priceData.obFeeDisplayMode === 'InQuote') {
    finalObFeeLabel = ', ' + ptc.priceData.obFeeName + ' ' + (0, _priceString2.default)(currencyformat, ptc.priceData.obFeeAmount, currency);
  }

  return '(' + text + ' ' + (0, _priceString2.default)(currencyformat, finalTaxValue, currency).trim() + (finalMarkupLabel || '') + (finalFeeLabel || '') + (finalObFeeLabel || '') + ')';
}

/*
The pricing information available for a hotel option is a list (array) of
per-night price descriptions and a total. This section of the code handles the
rendering of the per-night price descriptions. There may be more description
types than the ones currently being handled.
*/
function getHotelPriceFooterMessage(option) {
  return option.optionPrice.optionFooterMessage;
}

function getHotelPricePerNightDescriptors(option) {
  return option.optionPrice.priceItemList;
}

function getRefundableText(option) {
  return option.hotelRoom.rules.refundableText || [];
}

/**
Returns per-night price-descriptor-type title
*/
function getHotelPriceDescriptorTitle(priceItem, t) {
  switch (priceItem.priceData.rateType) {
    case 'AveragePerNight':
      {
        return t ? t('hotel.avg') : 'Avg. price per night';
      }

    case 'MinPrice':
      {
        return t ? t('hotel.min') : 'Min. price per night';
      }

    case 'MaxPrice':
      {
        return t ? t('hotel.max') : 'Max. price per night';
      }

    case 'PerNight':
      {
        return 'Price per night';
      }

    default:
      {
        return '';
      }
  }
}

/**
Returns per-night price-descriptor total price and currency
*/
function getHotelPriceDescriptorPrice(priceItem, currencyFormat) {
  return '' + (0, _priceString2.default)(currencyFormat, priceItem.priceData.totalPrice, priceItem.priceData.currency);
}

function numberOfNights(option) {
  return 1;
}

/**
Returns per-night price-descriptor tax
*/
function getHotelPriceDescriptorTax(priceItem, currencyFormat, t) {
  return '(' + (priceItem.priceData.includingTaxes ? t ? t('air.tax') : 'incl. tax' : t ? t('air.notax') : 'excl. taxes') + (priceItem.priceData.taxPrice ? ' ' + (0, _priceString2.default)(currencyFormat, priceItem.priceData.taxPrice, priceItem.priceData.currency) : '') + ')';
}

function getHotelNumberOfNights(option) {
  return option.hotelRoom.hotelProperty.numberOfNights;
}

function getHotelVendorCode(option) {
  return option.hotelRoom.hotelProperty.vendor.code;
}

/*
Helpers for `Car` related data. Ordered first by argument object
(option, journey, segment) and then alphabetically.
*/

function getCarPickupDateTime(option, format) {
  if (format) {
    return (0, _moment2.default)(option.carOption.segment.startDateTime).format(format);
  } else {
    return option.carOption.segment.startDateTime;
  }
}

function getCarDropOffDateTime(option, format) {
  if (format) {
    return (0, _moment2.default)(option.carOption.segment.endDateTime).format(format);
  } else {
    return option.carOption.segment.endDateTime;
  }
}

// not being used
function getCarPickupCityCode(option) {
  return option.carOption.segment.location.cityCode;
}

// not being used
function getCarDropOffCityCode(option) {
  if (option.carOption.segment.dropLocation) {
    return option.carOption.segment.dropLocation.cityCode;
  } else {
    return option.carOption.dropOff.airportCode;
  }
}

function getCarPickupCityName(option) {
  return option.carOption.segment.location.cityName;
}

function getCarDropOffCityName(option) {
  return option.carOption.dropOff.city;
}

function getCarPickupCountryName(option) {
  return option.carOption.pickUp.country;
}

function getCarDropOffCountryName(option) {
  return option.carOption.dropOff.country;
}

// not being used
function getCarPickupIsAirport(option) {
  return option.carOption.segment.location.isAirport;
}

function getCarPickupAirportCode(option) {
  return option.carOption.pickUp.airportCode;
}

function getCarDropOffAirportCode(option) {
  return option.carOption.dropOff.airportCode;
}

function getCarPickupLocationName(option) {
  return option.carOption.segment.location.name;
}

function getCarDropOffLocationName(option) {
  if (option.carOption.segment.dropLocation) {
    return option.carOption.segment.dropLocation.name;
  } else {
    return option.carOption.dropOff.name;
  }
}

function getCarExactLocationPickup(option) {
  return option.carOption.pickUp.address ? option.carOption.pickUp.address : '';
}

function getCarExactLocationDropoff(option) {
  return option.carOption.dropOff.address ? option.carOption.dropOff.address : '';
}

function getCarRentalCompanyName(option) {
  return option.carOption.segment.vendor.name;
}

function getCarTypeDescription(option) {
  return option.carOption.carTypeDescription;
}

function getCarRate(option) {
  return option.optionPrice.priceItemList[0].priceData.totalPrice.toFixed(2);
}

function getCarRateCurrency(option) {
  return option.optionPrice.priceItemList[0].priceData.currency;
}
/*
export function getCarRateType(option) {
  return option.optionPrice.priceItemList[0].priceData.rateType
}
*/
function getCarRateType(option, t) {
  switch (option.optionPrice.priceItemList[0].priceData.rateType) {
    case 'PerWeek':
      {
        return t ? t('car.perWeek') : 'Weekly rate';
      }
    case 'PerMonth':
      {
        return t ? t('car.perMonth') : 'Price monthly';
      }
    case 'PerWeekend':
      {
        return t ? t('car.perWeekend') : 'Weekly rate';
      }
    case 'PerPackage ':
      {
        return t ? t('car.perPackage') : 'Price per package';
      }
    default:
      {
        return t ? t('car.perDefault') : 'Price per day';
      }
  }
}

function getCarTotal(option) {
  return option.optionPrice.totalPriceItem.priceData.totalPrice.toFixed(2);
}

function getCarTotalCurrency(option) {
  return option.optionPrice.totalPriceItem.priceData.currency;
}

function getCarVendorCode(option) {
  return option.carOption.segment.vendor.code;
}

function getCarRatePerDistance(option) {
  return option.carOption.segment.rateTotal.extraMileageRate.toFixed(2);
}

function getCarRatePerDistanceUnits(option) {
  switch (option.carOption.segment.rateTotal.includedMileagePerDayUnit) {
    case 'Kilometers':
      {
        return 'km';
      }

    case 'Miles':
      {
        return 'mile';
      }

    default:
      {
        return '';
      }
  }
}

function getSymbolBeforeFlightNumber(journey) {
  var operatedByName = journey.operatingFlightName;
  var carrierName = journey.carrier ? journey.carrier.name : '';

  if (!operatedByName || operatedByName && operatedByName === carrierName) {
    return '';
  } else {
    return '@';
  }
}

function getCarRatePerDistanceCurrency(option) {
  return option.carOption.segment.rateTotal.currency.code;
}

/*
Helpers for `Rail Card` related data. Ordered alphabetically.
*/

function getCardNumber(option) {
  return option.cardNumber;
}

function getReceiptNumber(option) {
  return option.receiptNumber;
}

function getCurrencyCode(option) {
  return option.currencyCode;
}
/* REPEATED ON AIR
export function getRules(option) {
  return option.rules;
}
*/

function getCardTypeText(option) {
  return option.cardTypeText;
}

function getFromZoneName(option) {
  return option.fromZoneName;
}

function getFromZoneCode(option) {
  return option.fromZoneCode;
}

function getToZoneName(option) {
  return option.toZoneName;
}

function getToZoneCode(option) {
  return option.toZoneCode;
}

function getValidFrom(option) {
  return option.validFrom;
}

function getValidTo(option) {
  return option.validTo;
}

function getVendorName(option) {
  return option.vendorName;
}

function getRailCardOperatedBy(option) {
  return option.operatedBy;
}

function getClassName(option) {
  return option.className;
}

function getClassCode(option) {
  return option.classCode;
}

function getEquipement(option) {
  return option.equipement;
}

function getTariffCode(option) {
  return option.tariffCode;
}

function getPassengerTypeCode(option) {
  return option.passengerTypeCode;
}

function getDiscount(option) {
  return option.discount;
}

function getRailCardPrice(option) {
  return option.price;
}

function getAction(option) {
  return option.action;
}

function getTravelerName(option) {
  return option.travelerName;
}

function getRulesItemNumber(option) {
  return option.rulesItemNumber;
}

function getRulesfareReference(option) {
  return option.rulesfareReference;
}

/*
Common helpers
*/

function getReferenceNumber(basket) {
  return basket.header.refNum;
}

function getTimeFormat(basket) {
  return basket.timeFormat;
}

function addComma(val) {
  return val ? val + ', ' : '';
}

function addBrackets(val) {
  return val ? ' (' + val + ')' : '';
}

function existVal(val) {
  return val ? val : '';
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/basketHelpers.js
// module id = 39
// module chunks = 0